<template>
  <div class="taskPreview">
    <el-row class="row">
      <el-col :span="5">
        <span class="label">{{ $t('taskPreview.projectName') }}</span>
      </el-col>
      <el-col :span="10">
        <span>{{taskData.projectName}}</span>
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col :span="5">
        <span class="label">{{ getArchiveLabel }}</span>
      </el-col>
      <el-col :span="10">
        <div class="textDecoration">{{taskData.javaPackageName}}</div>
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col :span="5">
        <span class="label">{{ $t('taskPreview.javaArchiveUrl') }}</span>
      </el-col>
      <el-col :span="10">
        <div class="textDecoration">{{taskData.sandboxTargetServiceUrl}}</div>
      </el-col>
    </el-row>
    <el-row
      class="row"
      v-if="taskData.sourceCodeInfos?.length"
    >
      <el-col :span="5">
        <span class="label">{{ $t('taskPreview.sourceCode') }}</span>
      </el-col>
      <el-col :span="10">
        <ul style="list-style: none;padding: 0;">
          <li
            v-for="item in taskData.sourceCodeInfos"
            :key="item.id"
            class="textDecoration"
          >
            {{item.fileName}}
          </li>
        </ul>
      </el-col>
    </el-row>
    <template v-if="loginInfoList.length > 0">
      <div
        v-for="item in loginInfoList"
        :key="item.startUrl"
      >
        <el-row
          class="row"
          v-if="item.startUrl"
        >
          <el-col :span="5">
            <span class="label">{{ $t('taskPreview.loginUrl') }}</span>
          </el-col>
          <el-col :span="10">
            <div class="textDecoration">{{item.startUrl}}</div>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="5">
            <span class="label">{{ $t('taskPreview.testAccount') }}</span>
          </el-col>
          <el-col :span="10">
            <div
              v-for="(roleList, roleLabel) in item.accountsInfo"
              :key="roleLabel"
            >
              {{`${roleLabel} x ${roleList.length}`}}
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
  </div>
</template>

<script>
import { LANGUAGE_TYPES, RoleOptions } from '@/enum';

export default {
  name: 'TaskPreview',
  inject: ['taskData'],
  props: {
    payload: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const { testAccounts = [] } = this.payload;
    return {
      testAccounts,
    };
  },
  computed: {
    loginInfoList() {
      return this.testAccounts.reduce((acc, account) => {
        const { startUrl, role } = account;
        const roleLabel = RoleOptions.find((item) => item.value === role)?.label;

        const existingLoginInfo = acc.find((info) => info.startUrl === startUrl);

        if (existingLoginInfo) {
          if (!existingLoginInfo.accountsInfo[roleLabel]) {
            existingLoginInfo.accountsInfo[roleLabel] = [];
          }
          existingLoginInfo.accountsInfo[roleLabel].push(account);
        } else {
          acc.push({
            startUrl,
            accountsInfo: {
              [roleLabel]: [account],
            },
          });
        }

        return acc;
      }, []);
    },
    getArchiveLabel() {
      return this.lang === LANGUAGE_TYPES.JAVA ? this.$t('taskPreview.javaArchive') : this.$t('taskPreview.javascriptArchive');
    },
  },
};
</script>

<style lang="scss" scoped>
.taskPreview {
  .label {
    font-weight: bold;
    white-space: nowrap;
  }

  ul {
    padding: 0 0 0 15px;
    margin: 0;
  }

  .row {
    margin-bottom: 20px;
    line-height: 40px;
  }

  .textDecoration {
    text-decoration: underline;
  }
}
</style>